import { render } from "./page-content.vue?vue&type=template&id=16f83686&scoped=true&ts=true"
import script from "./page-content.vue?vue&type=script&lang=ts"
export * from "./page-content.vue?vue&type=script&lang=ts"

import "./page-content.vue?vue&type=style&index=0&id=16f83686&scoped=true&lang=css"

import exportComponent from "/vercel/path2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f83686"]])

export default __exports__